import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
// child
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";
import ImageUpload from "../../ChildComponents/ImageUpload";
import Select from "../../ChildComponents/Select";

// validationSchema
import { Rolechema } from "../validation/roleValidation";

// api
import { useGetCategory } from "../../store/api/categoryApi";

import { useCreateSection, useUpdateSection } from "../../store/api/sectionApi";

function SectionFrom({ data, editId, onSuccessCreated }) {
  const updateSection = useUpdateSection(editId?._id);
  // init
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  const getCategory = useGetCategory();
  const {
    data: categoryData,
    isLoading: isRoleLoading,
    error: roleError,
  } = useQuery({ queryKey: "category", queryFn: getCategory });

  const transformedCategory = categoryData?.categorys?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  useEffect(() => {
    if (editId && transformedCategory?.length) {
      const selectedCategory = transformedCategory.find(
        (item) => item.value === editId.category._id
      );

      reset({
        idNumber: editId?.idNumber || "",
        category: selectedCategory || null,
      });
      setEdited(true);
    }
  }, [editId, reset]);

  const createSection = useCreateSection();

  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId ? updateSection(data) : createSection(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Creatred Successfuly");
      reset();
      onSuccessCreated(1);
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);

    try {
      mutation.mutate({
        idNumber: formData?.idNumber,
        category: formData?.category?.value || "",
      });
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <div className="row">
          <div className="col-sm-9">
            <div className="row">
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("idNumber")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`1,2`}
                  label="Id Number"
                />
              </div>
              <div className="col-sm-4">
                <Controller
                  name="category"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isClearable
                      options={transformedCategory}
                      placeholder="Select Category"
                      label="Select Category"
                    />
                  )}
                />
              </div>
              <BrandButton
                type="submit"
                title={`Save Change`}
                className="my-5"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SectionFrom;
